import React from 'react';

import PropTypes from 'prop-types';

import {
  DropdownMenuContent as ShadcnDropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';
import { useSidebar } from '@/components/ui/sidebar';
import { DROPDOWN_MENU_CONTENT_CLASSES, WORKSPACES } from '../../../../constants';
import AddWorkspaceButton from './AddWorkspaceButton';
import WorkspaceButton from './WorkspaceButton/WorkspaceButton';

const DropdownMenuContent = ({ setActiveWorkspace }) => {
  const { isMobile } = useSidebar();

  const handleWorkspaceSelect = (workspace) => {
    setActiveWorkspace(workspace);
  };

  return (
    <ShadcnDropdownMenuContent
      align="start"
      className={DROPDOWN_MENU_CONTENT_CLASSES}
      side={isMobile ? 'bottom' : 'right'}
      sideOffset={4}
    >
      <DropdownMenuLabel className="text-muted-foreground text-xs">
        Workspaces
      </DropdownMenuLabel>

      {WORKSPACES.map((workspace) => {
        const { name, logo } = workspace;

        return (
          <WorkspaceButton
            key={name}
            logo={logo}
            name={name}
            onClick={() => handleWorkspaceSelect(workspace)}
          />
        );
      })}

      <DropdownMenuSeparator />
      <AddWorkspaceButton />
    </ShadcnDropdownMenuContent>
  );
};

DropdownMenuContent.propTypes = {
  setActiveWorkspace: PropTypes.func.isRequired,
};

export default DropdownMenuContent;
